<app-score-dashboard [title]= "'Safety ' + typeLabel"
                     [trendingTitle]="'Safety ' + typeLabel + ' Trending'"
                     [centerText]="typeLabel" 
                     [employeeId]="employeeId" 
                     [daysLookBack]="daysLookBack" 
                     [palette]="palette"
                     [showScore]="true" 
                     [showTrending]="true" 
                     [loadScoreData]="loadScoreData" 
                     [loadTrendingData]="loadTrendingData"
                     [useCapitalCaseFormatting]="false"
                     [exportData]="exportData" formatMode="decimal">
</app-score-dashboard>